module.exports = "pegasus/assets/theme2/google.png";